/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Page, { type IPageAttrs } from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import type Mithril from 'mithril';
import BookshelfHero from './BookshelfHero';
import BookList from './BookList';
import BookshelfFilter from './BookshelfFilter';
import BookshelfPageState from '../states/BookshelfPageState';
import * as terms from '@fof-terms';
const UpdateAlert = terms.components.UpdateAlert;

export interface BookshelfPageAttrs extends IPageAttrs {}

export default class BookshelfPage<CustomAttrs extends BookshelfPageAttrs = BookshelfPageAttrs> extends Page<CustomAttrs, BookshelfPageState> {
	titleHasBeenSet!: boolean;

	oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
		super.oninit(vnode);

		// @ts-expect-error -- deliberate single-argument push, a title would land on the stack.
		app.history.push('book_collection');
		this.titleHasBeenSet = false;

		if (!app.bookshelfPageState) {
			app.bookshelfPageState = new BookshelfPageState();
		}

		this.state = app.bookshelfPageState;

		this.state.refresh();

		this.bodyClass = 'App--bookshelf';
	}

	onbeforeupdate(vnode: Mithril.VnodeDOM<CustomAttrs, this>) {
		super.onbeforeupdate(vnode);

		const { bookshelf } = this.state;

		if (!this.titleHasBeenSet && bookshelf) {
			app.setTitle(bookshelf.name());
			this.titleHasBeenSet = true;
		}
	}

	view(): Mithril.Children {
		const { bookshelf, loading } = this.state;

		return (
			<div className="BookshelfPage">
				{UpdateAlert && <UpdateAlert />}
				<BookshelfHero bookshelf={bookshelf} />
				<div className="container">
					{bookshelf && [<BookshelfFilter bookshelf={bookshelf} />, <BookList bookshelf={bookshelf} parentLoading={loading} />]}
					{loading && !bookshelf && <LoadingIndicator />}
				</div>
			</div>
		);
	}
}
